import React, { useEffect, useState } from "react";
import { Col, DatePicker, Form, Input, InputNumber, Row, Select, Space } from "antd";
import Styles from "./Styles";
import moment from "moment";
import { apiGetPath } from "../../api/api";
import { isEmpty } from "../../utils/comm";

const { Option } = Select;
const requredRlues = { required: true, message: "필수입력입니다." };

/* 한 Row에 2컬럼인 폼의 컬럼분할 비율 */
const responsiveColOption = {
  sm: 24,
  md: 11,
};

function PopRegistServiceUse({ onFinish, children }) {
  const [form] = Form.useForm();
  const [startDt, setStartDt] = useState(moment());
  const [endDt, setEndDt] = useState(moment());
  const [subPeriod, setSubPeriod] = useState(6);
  const [list, setList] = useState({ catCd: "", catNm: "", codeNm: "", devTp: "" });

  const onChangeStartDt = (e) => {
    setStartDt(e);
  };
  const onChangeEndDt = (e) => {
    setEndDt(e);
  };
  const disabledDate = (current) => {
    return current < startDt.endOf("day");
  };

  useEffect(() => {
    form.setFieldsValue({
      devTp: list.devTp,
    });
  }, [list]);

  const validatePhoneNumber = (validate, value) => {
    if (
      /(\d{4})-(\d{4})$/.test(value) ||
      /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/.test(value) ||
      /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/.test(value)
    ) {
      return Promise.resolve();
    } else {
      return Promise.reject(new Error(validate.message));
    }
  };

  const onChangeTelNum = (e) => {
    let value = e.target.value;
    let reValue = value.replaceAll("-", "");

    if (/[^0-9]/g.test(reValue)) {
      return;
    } else {
      switch (reValue.length) {
        case 8:
          reValue = reValue.replace(/(\d{4})(\d{4})/, "$1-$2");
          break;
        case 9:
          reValue = reValue.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
          break;
        case 10:
          reValue = reValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
          break;
        case 11:
          reValue = reValue.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
          break;
      }

      form.setFieldsValue({
        ...initialValues,
        telNum: reValue,
      });
    }
  };

  const validateCompCorpNum = (validate, value) => {
    if (!/^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/.test(value)) {
      return Promise.reject(new Error(validate.message));
    } else {
      return Promise.resolve();
    }
  };

  const onChangeCompCorpNum = (e) => {
    let value = e.target.value;
    if (/[^0-9]/g.test(value)) {
      return;
    } else {
      form.setFieldsValue({
        ...initialValues,
        compCorpNum: value.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3"),
      });
    }
  };

  const onChangeSiteCorpNum = (e) => {
    let value = e.target.value;
    if (/[^0-9]/g.test(value)) {
      return;
    } else {
      form.setFieldsValue({
        ...initialValues,
        siteCorpNum: value.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3"),
      });
    }
  };

  const onChangeSelectBoxValue = async (catCd) => {
    const response = await apiGetPath(`Device/service/${catCd}`);
    try {
      if (response.code === 0) {
        setList(response.data);
      } else if (response.code === 10) {
        setList({ catCd: "", catNm: "", codeNm: "", devTp: "" });
      }
    } catch (error) {}
  };

  const onChangeSubPeriod = (e) => {
    setSubPeriod(e);
    setEndDt(moment(startDt).add(e, "months"));
  };

  const initialValues = {
    startDt: moment(),
    endDt: moment().add(6, "months"),
    subPeriod: "6",
    statCd: "SUS00010",
  };

  useEffect(() => {
    form.setFieldsValue({
      endDt: endDt,
    });
  }, [subPeriod]);

  useEffect(() => {
    form.resetFields();
  }, [onFinish]);

  return (
    <Styles>
      <Form
        name='basic'
        className='label-w-150'
        autoComplete='off'
        onFinish={onFinish}
        id='formSvcIns'
        initialValues={initialValues}
        form={form}
      >
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='고객사' name='compNm' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item
                label='고객사 사업자 등록번호'
                name='compCorpNum'
                // rules={[{...requredRlues}]}
                rules={[
                  {
                    required: true,
                    validator: validateCompCorpNum,
                    message: "올바른 사업자 등록번호 양식이 아닙니다.",
                  },
                ]}
              >
                <Input onChange={onChangeCompCorpNum} maxLength={12} />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='사업장' name='siteNm' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item
                label='사업장 사업자 등록번호'
                name='siteCorpNum'
                // rules={[{...requredRlues}]}
              >
                <Input onChange={onChangeSiteCorpNum} maxLength={12} />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='주소' name='address' rules={[{ ...requredRlues }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item label='서비스 요청번호'>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <hr />
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item label='담당자' name='userNm' rules={[{ ...requredRlues }]}>
              <Input maxLength={25} />
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item
              label='이메일'
              name='mail'
              rules={[{ type: "email", ...requredRlues, message: "올바른 이메일 형식이 아닙니다." }]}
            >
              <Input maxLength={30} />
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item
              label='연락처'
              name='telNum'
              rules={[
                {
                  required: true,
                  validator: validatePhoneNumber,
                  message: "올바른 전화번호 양식이 아닙니다.",
                },
              ]}
            >
              <Input onChange={onChangeTelNum} maxLength={13} />
            </Form.Item>
          </Col>
        </Form.Item>
        <hr />
        <Form.Item>
          <Col {...responsiveColOption}>
            <Form.Item label='신청 서비스' name='catCd' rules={[{ ...requredRlues }]}>
              <Select
                onChange={onChangeSelectBoxValue}
                placeholder={"선택"}
                allowClear
                showArrow={true}
                showSearch={false}
              >
                {children.map((item, index) => (
                  <Option value={item.catCd} key={index}>
                    {item.catNm}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item label='디바이스 수량'>
          <Form.Item name='devTp' className='fwn' hidden={true} initialValue='DEV00010'>
            <Input hidden={true} />
          </Form.Item>
          <Form.Item label={list.codeNm} name='devNum' className='fwn' initialValue={1} rules={[{ ...requredRlues }]}>
            <Space>
              <InputNumber style={{ width: 140 }} defaultValue={1} type={"number"} min={1} />대
            </Space>
          </Form.Item>
        </Form.Item>
        <Form.Item label='서비스 개시 요청일' name='startDt'>
          <DatePicker format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]} allowClear={false} onChange={onChangeStartDt} />
        </Form.Item>
        <Form.Item label='구독기간(약정기간)' name='subPeriod'>
          <Select onChange={onChangeSubPeriod} style={{ width: 132 }}>
            <Option value='6'>6개월</Option>
            <Option value='12'>12개월</Option>
            <Option value='36'>36개월</Option>
          </Select>
        </Form.Item>
        <Form.Item label='서비스 만료일' name='endDt'>
          <DatePicker
            format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
            allowClear={false}
            disabledDate={disabledDate}
            onChange={onChangeEndDt}
          />
        </Form.Item>
        <Form.Item label='월 구독료' name='subPay'>
          <Space>
            <InputNumber type={"number"} step={1000} style={{ width: 132 }} />원 (VAT별도)
          </Space>
        </Form.Item>
      </Form>
    </Styles>
  );
}

export default PopRegistServiceUse;
